/** Resolve the Radix scroll viewport inside a shadcn ScrollArea wrapper. */
export function queryScrollAreaViewport(
  scrollAreaRoot: HTMLElement | null | undefined,
): HTMLDivElement | null {
  if (!scrollAreaRoot) return null;
  if (scrollAreaRoot.dataset.slot === "scroll-area-viewport") {
    return scrollAreaRoot instanceof HTMLDivElement ? scrollAreaRoot : null;
  }
  const nested = scrollAreaRoot.querySelector<HTMLDivElement>('[data-slot="scroll-area-viewport"]');
  if (nested) return nested;
  return scrollAreaRoot instanceof HTMLDivElement ? scrollAreaRoot : null;
}
